import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

$(document).ready(function () {

    flatpickr('.datepicker', {
        dateFormat: "Y-m-d",
        locale: "es"
    });

    flatpickr(".datepicker-month", {
        plugins: [
            new monthSelectPlugin({
                shorthand: true,
                dateFormat: "Y-m",
                altFormat: "F Y",
                theme: "light"
            })
        ],
        locale: "es"
    });



    $('.chosen-select').chosen({width: '100%'});

    window.togglePreloader = function () {
        // Verifica si la imagen dentro del preloader está visible
        if ($('.preloader img').is(':visible')) {
            // Si está visible, oculta el preloader y la imagen
            $('.preloader').css('height', '0px');
            $('.preloader img').hide();
        } else {
            // Si no está visible, muestra el preloader y la imagen
            $('.preloader').css('height', '100vh');
            $('.preloader img').show();
        }
    }


    window.loading_small = function (div, size = '200px') {
        if ($("#" + div).length > 0) {
            document.getElementById(div).innerHTML = '<center><img src="' + window.location.origin + '/images/loading.gif" style="width:' + size + ';" /></center>';
        }
    }

    $(function () {
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        });
    })

    window.ResponseFail = function (jqXHR) {
        //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
        if (jqXHR['status'] == 422) {

            let errors = "<ul class=''>";
            let items = "";

            $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                items = items + "<li class=''>" + value + "</li>";
            });

            errors = errors + items + "</ul>";
            let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                + errors
                + "</div></div></div>";
            document.getElementById('div_message').innerHTML = view;
        } else {
            console.log(jqXHR['status']);
            alert("Disculpe, existió un problema");
        }

        $("#div_result").html("");

    }

})
;
